import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PATH_CLIENT_ADD, PATH_CLIENT_EDIT } from 'routing/path'
import PageHeader from 'components/page-header'
import ClientSearchFilter from 'components/search-filters/client-search-filter'
import Table from 'components/table'
import { useGetClientsQuery } from 'actions/client/client-api';
import { translationApi  } from 'actions/translation-api';
import { changePage  } from 'store/client/slice.client-list-filter';

const ClientList = () => {
	const dispatch = useDispatch();

	const clientListFilter = useSelector(state => state.clientListFilter);
	const { data: clientList } = useGetClientsQuery(clientListFilter, { refetchOnMountOrArgChange: true });
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const changeClientListPage = (filterChange) => {
        dispatch(changePage(filterChange.page));
	}

	const headers = [translations.number, translations.name, translations.vatin, translations.postalCode, translations.city, translations.street];
	let rows = [];
	if (clientList && clientList.clients) {
		rows = clientList.clients.map(function (client) {
			return {
				className: client.measurementsWithoutResults && client.dosemetersToSend ? "yellow-background" : client.measurementsWithoutResults ? "red-background" : client.dosemetersToSend ? "green-background" : "",
				link: PATH_CLIENT_EDIT + client.clientId,
				columns: [client.clientId.toString().padStart(4, '0'), client.name, client.vatin, client.address.postalCode, client.address.city, client.address.street]
			}
		});
	}
	const buttons = [<Link id="addClientButton" key="addClientButton" className="btn btn-primary me-2" to={PATH_CLIENT_ADD}>{translations.actionAddClient}</Link>];

	return (
		<div>
			<PageHeader title={translations.clientList} buttons={buttons} breadcrumbs={[]} breadcrumbsCurrentPage={translations.clientList} />
			<ClientSearchFilter />
			<Table fetchList={changeClientListPage} headers={headers} rows={rows} pagination={clientList?.pagination} translations={translations} />
		</div>
	);
}

export default ClientList;
